import { render, staticRenderFns } from "./SingleUpload.vue?vue&type=template&id=6f463ae7&scoped=true"
import script from "./SingleUpload.vue?vue&type=script&lang=js"
export * from "./SingleUpload.vue?vue&type=script&lang=js"
import style0 from "./SingleUpload.vue?vue&type=style&index=0&id=6f463ae7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f463ae7",
  null
  
)

export default component.exports